import styled from "styled-components";

export const PillContainer = styled.div<{ isSticky: boolean; isVisible: boolean }>(
    ({ theme, isSticky, isVisible }) => ({
        display: "flex",
        gap: theme.spacing.xSmall,
        overflow: "scroll",
        scrollbarWidth: "none",
        paddingLeft: theme.spacing.medium,
        paddingRight: theme.spacing.medium,
        marginTop: theme.spacing.xLarge,
        transition: "opacity 0.2s ease, transform 0.2s ease",
        transform: isVisible ? "translateY(0)" : "translateY(-10px)",
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
        ...(isSticky && {
            position: "absolute",
            top: "0px",
            paddingTop: theme.spacing.large,
            paddingBottom: theme.spacing.xSmall,
            zIndex: 10,
            marginTop: 0,
            width: "100%",
            background: theme.colors[theme.colorMode].background_Primary,
        }),
    })
);
